<template>
  <div class="header">
    <div class="logoAndTitle">
      <a
        :href="logoUrl()"
        class="utdLogo"
        aria-label="UpToDate logo" />
      <div class="headerTitle">User Management</div>
    </div>
    <div
      v-if="showHeader"
      class="logout">
      <div
        v-if="adminNameExists"
        class="adminInfo">
        <span class="wk-icon-user adminIcon" />
        <div class="adminName">{{ adminFullName }}</div>
      </div>
      <console-button
        class="logoutLink"
        button-type="button"
        button-size="default"
        @on-click="logout()">
        Log Out
      </console-button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ConsoleButton from './ConsoleButton.vue';
import Cookies from 'js-cookie';

export default {
    components: {
        ConsoleButton
    },
    computed: {
        ...mapGetters([
            'isAuthenticated',
            'loggedIn'
        ]),
        ...mapGetters('admin', [
            'adminFirstName',
            'adminLastName'
        ]),

        adminFullName() { 
            return `${this.adminFirstName} ${this.adminLastName}`;
        },

        adminNameExists() {
            return this.adminFirstName || this.adminLastName;
        },

        showHeader() {
            return Cookies.get('loggedIn') || this.loggedIn;
        }
    },
    beforeMount() {
        if (Cookies.get('loggedIn') || this.loggedIn) {
            this.getAdminIdentifier();
        }
    },
    methods: {
        ...mapActions([ 
            'logoutUser'
        ]),
        ...mapActions('admin', [
            'getAdminIdentifier'
        ]),
        logoUrl() {
            const isAuthenticated = !!(typeof this.authToken === 'undefined' ? Cookies.get('authToken') : this.authToken);
            return isAuthenticated ? '/manage' : '/login';
        },
        logout() {
            this.logoutUser(); 
        }
    }
};

</script>

<style lang="scss">
    .header {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        padding-top: 40px;
        margin-left: 56px; 
        margin-right: 129px;
    }

    .logoAndTitle {
        display: flex;
        align-items: center;
    }

    .adminInfo {
        display: flex;
        gap: 5px;
        align-items: center;
    }

    .admin {
        display: flex;
        align-items: center;
        gap: 5px;
    }

    .adminName {
        color: $HEADER-ADMIN-NAME
    }

    .adminIcon {
        color: $HEADER-ADMIN-ICON;
    }
    .adminInfo{
        display: flex;
    }

    .utdLogo {
        display: block;
        height: 35px;
        width: 143px;
        background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOYAAAA3CAMAAAAv1sYDAAAANlBMVEUAAAB8v0l8v0l8v0l8v0l8v0l8v0l8v0l8v0l8v0l8v0l8v0l8v0l8v0l8v0l8v0l8v0l8v0k73np/AAAAEXRSTlMAIJ/vrzAAz1AQv2CAQN+PcOqVOWwAAASVSURBVHhe7drpkqQgDADggcgRwiHv/7LbbUq3A9q4llM7NdX5NVWK4eNq0Pn6zaE01FonY+2X/b1hwHm0PlSyX/URcQcQnxfSMSDW49BvAeG1QA6F1PcoEbSNMSpbqvkWphkyZbgZv4E5A9qqA6AN03cwsx0w+4B4PzQUa2vCB4LqZSaFLdzSI2GLecyEteAWOZ0GIE3mBBPowdTOoU0XmTJSe+uYGVaAIQ2VI55DpklkGzCnaux/Z3JQHqxc1yrGg3Zy1hL8bybHzD0638nkJSgpmG3WP4NpDXdoupOJ2WFCa4wG9UOYFoHX6BuZ1uRMxlAAsj+FaU19Bt3JtBhzraCVPc1McwzPmGI6yUQqzwKF8BTTxqY70ccgH9Az+3TR7FjOMXEWGxfQasxUum6h1ZC5DVtvOci9JCzIafqYNzysF7K/yIy1jYIDpiwC84i5ldGMzFKTzQFTscK4V7u+i1kdvmXqfjM/ZqonAPivNgB3mRMjDDTZrjNd9OkR0QmnZEolaJ+S18DOMdPmrX/0UpzSQ0B5LW/CEvlla8njEx1vi421PlQGXWEKRmJoOGbO3NLIAJwWpx8z9ZZHQaam0dTxElRe250WsrrObPJSy5RriW7uBxwy49+6mO5IMx8yFSvlFL+BaZf+yUfMWFuH4yQjJh3UxfM0lMymFY0c+3AHE0HAGiZsY0zcAENmOqqLaLeOCdwIcs74G5gML/tMvzNoAme+ygzvmKlVKa7cDUyeDvtMzaR+OJYR019hMhtt073hDibPtn1mWNO2zRJOLkEy0iNcz2wWiq5V4A4mP9vsMkVHi/l6ijlbDiQd6ho9U6JqeA1OdgNTyHtmrwhnmOEvAAuw7iRTxs9mLjIUu7dfyDQ83F+UocRHpOTuYZZ/ZpZvYOqtKrxHJdwkIyb0gJYpk0qIaplyOT1k5gtLEMK6rPlmWzpm1iETRK3a0pIpqw33/qAUvmftVvqn300zYi4c1SmRJ4pkymk07TPLte2BqZxFDsMxk/t+HjG73+S+Yj1T86OPN3vT2c2eHLKhnd1jJndIHjHNekoSgZmHgmTKlsd3W3fzb1t343g+bkw3ZMqtCg2YvKyFvVUvH7WfE7vzlhnbauLwIOaBj977s9vAAVMcpAfMtGTQ2Cmrl0ypBLztWO1DFQd1LecR8ZtqofLdBtvheyZ3es1kxWuQ9iBL4sOOSJT2FoUaFCOUe/eSRPmSGQkkyq9oNVUOkW3ixNyWpimPlKlnIqtq1nNKaea03WuHmgulROtVssdMW/ieaU5pnhhR9r5vBhZyuub8X2t45luQgqn42T5Ft1aDGJCLfwDi9LR0THaKEEpmimDl9ReYMvo3uaa5qJm5Uz4f1ZAaJkOgdURrj5kujd66EwgE2bfMIK63xQMubCVWJI5t5fENIJs9plUxv95UlD1mOjrxDQU1iG8DR0zgbyRtKL5pXTNAJEjQ/8cCvvbU5PslaA1DcVq+BZHZ3cWnqJeryp4MHyf+tHQp1LykM3vXkMrOk1MsIYSym/DrwhfFnx6/kPlhfpgf5of5YX6YH+aH+WF+mH8AG5eU+7+W5LMAAAAASUVORK5CYII=") no-repeat 0px/143px 35px;
    }

    .headerTitle {
        font-size: 21px;
        font-weight: 300;
        height: 28px;
        width: 178px;
        color: $HEADER-TITLE;
        margin-left: 15px;
    
    }

    .logout {
        display: flex;
        align-items: center;
        font-size: 14px;
        font-weight: normal; 
        gap: 48px;
    }

    .logoutLink { 
        padding: 0px;
        width: fit-content;
        text-decoration: none;
        background: transparent;
        border-color: transparent;
        color: $HEADER-LOGOUT-LINK;     
    }

    .logoutLink:hover {
        color: $HEADER-LOGOUT-LINK-HOVER;
        font-size: 14px;
        font-weight: normal;
        line-height: 18px;
        text-decoration: none;
        background: transparent;
        border-color: transparent;
        padding: 0px;
    }
</style>